export default __webpack_public_path__ + "static/media/main_image.fcc210c2.png";